import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type FilterGroupState, type GlobalsFilters } from '../types';

const updateGlobalsFiltersCase: CaseReducer<
  FilterGroupState,
  PayloadAction<Partial<GlobalsFilters>>
> = (state, action) => {
  state.globals = { ...state.globals, ...action.payload };

  return state;
};

export { updateGlobalsFiltersCase };
